import { render, staticRenderFns } from "./PaginaFornecedorHeader.vue?vue&type=template&id=01171df8&scoped=true&"
import script from "./PaginaFornecedorHeader.vue?vue&type=script&lang=js&"
export * from "./PaginaFornecedorHeader.vue?vue&type=script&lang=js&"
import style0 from "./PaginaFornecedorHeader.vue?vue&type=style&index=0&id=01171df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01171df8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
